import { render, staticRenderFns } from "./SourceTypeSelectionModal.vue?vue&type=template&id=6d8bc304&scoped=true"
import script from "./SourceTypeSelectionModal.vue?vue&type=script&lang=js"
export * from "./SourceTypeSelectionModal.vue?vue&type=script&lang=js"
import style0 from "./SourceTypeSelectionModal.vue?vue&type=style&index=0&id=6d8bc304&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8bc304",
  null
  
)

export default component.exports